import { z } from 'zod'
import { Currency } from '../types/enums'

export const CreateOfficeSchema = z.object({
  name: z
    .string({ required_error: 'Ofis adı zorunludur.' })
    .min(2, 'Ofis adı en az 2 karakter olmalıdır.')
    .max(100),
  city: z.string({ required_error: 'Şehir zorunludur.' }).min(2).max(100),
  country: z.string().min(2).max(100).default('Türkiye'),
  timezone: z.string().min(3).max(100).default('Europe/Istanbul'),
  currency: z.nativeEnum(Currency).optional(),
  workHoursPerDay: z.number().min(1).max(24).default(8),
  workDaysPerWeek: z.number().int().min(1).max(7).default(5),
  /** [IK-01] Maksimum haftalık saat */
  maxWeeklyHours: z.number().min(1).max(168).default(40),
  timesheetDeadlineHour: z.number().int().min(0).max(23).default(18),
  timesheetDeadlineMin: z.number().int().min(0).max(59).default(30),
  timesheetMinPrecision: z
    .number()
    .refine((v) => v === 0.25 || v === 0.5, {
      message: 'Timesheet hassasiyeti 0.25 veya 0.5 olmalıdır.',
    })
    .default(0.5),
})

export const UpdateOfficeSchema = CreateOfficeSchema.partial().extend({
  isActive: z.boolean().optional(),
})

export type CreateOfficeInput = z.infer<typeof CreateOfficeSchema>
export type UpdateOfficeInput = z.infer<typeof UpdateOfficeSchema>
